import { validationMixin } from "vuelidate";

export default {
	mixins: [validationMixin],
	props: {
		fetching: {
			type: Boolean,
			default: () => false
		},
		errorMessage: {
			type: String,
			default: () => null
		},
		successMessage: {
			type: String,
			default: () => null
		},
		message: {
			type: String,
			default: () => null
		},
		messageType: {
			type: String,
			default: () => "is-success"
		}
	},
	methods: {
		clearMessages() {
			this.$emit("clear-messages");
		}
	},
	computed: {
		isValid() {
			return !this.$v.$invalid;
		}
	}
};
